import React from 'react';
// import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';

import PartnersCarousel from '../components/PartnerCarousel';


import './Home.css';


const generateRandomStars = (numStars: number) => {
  const stars = [];
  for (let i = 0; i < numStars; i++) {
    const size = Math.random() * 3 + 1; // Random size between 1px and 3px
    const top = Math.random() * 40; // Random top
    const left = Math.random() * 100; // Random left position between 0% and 100%
    // Random animation duration between 10 and 70 seconds
    const animationDuration = Math.random() * 60 + 10;
    const animationDelay = Math.random() * 10; // Random delay between 0 and 10 seconds
    // const animationDuration = 1; // For debug
    // Random color between white and lightblue
    const color = "ffffff";
    stars.push({ top: `${top}%`, left: `${left}%`, size: `${size}px`, animationDuration: animationDuration, color: color, animationDelay: animationDelay });
  }
  return stars;
};

const stars = generateRandomStars(21); // Generate 20 random stars


const Home: React.FC = () => {
  const navigate = useNavigate();

  const handleContactClick = () => {
    navigate('/contact');
  };

  return (
    <div className='home'>

      {/* Blinking stars */}
      {stars.map((star, index) => (
        <div
          key={index}
          className="star"
          style={{
            top: star.top,
            left: star.left,
            width: star.size,
            height: star.size,
            animationDuration: `${star.animationDuration}s`,
            animationDelay: `${star.animationDelay}s`,
            backgroundColor: `#${star.color}`
          }}
        ></div>
      ))}

      {/* Empty div */}
      <div style={{ height: '100px' }}></div>

      {/* Mission Statement Card */}
      <div className="mission-card-container">
        <div className="mission-card">
          <div className="mission-card-content">
          <h1>My Mission</h1>
          <p>
            I bring technical rigor and clear thinking to problems where business goals, risk, and engineering reality collide. I help teams validate assumptions, make sound trade-offs, and build systems that perform under real constraints and keep working over time.
            I'm at my best when I can connect strategy to execution. I enjoy turning vague goals into concrete plans, validating assumptions with lightweight tests, and then building systems that are reliable, secure, and maintainable.
          </p>
          <p>
            This website also serves as an archive of personal projects.
          </p>

            <Button label="Contact Me" icon="pi pi-envelope" onClick={handleContactClick} className="p-button-rounded p-button-info p-button-outlined button-white" />
          </div>
        </div>
      </div>

      <div style={{ height: '100px' }}></div>

      {/* Partners Carousel */}
      <PartnersCarousel />
    </div>
  );
};

export default Home;
